import React from 'react';
import { CheckInForm } from './components/CheckInForm';
export function App() {
  return <main className="checkin-page w-full min-h-full bg-white py-10 sm:py-16 px-4" data-id="element-0">
      <div className="checkin-container max-w-[640px] mx-auto" data-id="element-1">
        <header className="text-center mb-8 sm:mb-10" data-id="element-2">
          <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 tracking-tight" data-id="element-3">
            Welcome to Kosin's Glass
          </h1>
          <p className="mt-4 text-base sm:text-lg text-gray-700" data-id="element-4">
            Please check in below and a member of our team will be with you
            shortly.
          </p>
          <p className="mt-2 text-sm sm:text-base text-gray-500" data-id="element-5">
            Tell us what type of glass service you need so we can direct you to
            the right person.
          </p>
        </header>

        <CheckInForm data-id="element-6" />

        <div className="text-center mt-6" data-id="element-7">
          <a href="#send-to-phone" className="checkin-send-link inline-block text-sm text-gray-600 hover:text-[#C8102E] underline underline-offset-4" data-id="element-8">
            Click Here to send this page to my phone
          </a>
        </div>
      </div>
    </main>;
}